import React from 'react';

import { Form, Input, Tag } from 'antd';

import { isBorrowSealItem, isBorrowWatermarkEnabled, borrowCopyTypeLabel } from './certBorrowDisplayUtils';

import './CertBorrowApplicationView.css';



function parseItemsFromFormData(formData) {

  if (formData?.borrow_items?.length) return formData.borrow_items;

  const entries = formData?.borrow_entries || [];

  const items = [];

  entries.forEach((entry) => {

    (entry.certificates || []).forEach((cert) => {

      items.push({

        company_id: entry.company_id,

        company_name: entry.company_name,

        cert_name: cert.cert_name,

        cert_type_name: cert.cert_type_name,

        copy_type: cert.copy_type,

        copy_type_label: cert.copy_type_label,

        need_watermark: cert.need_watermark,

        watermark_text: cert.watermark_text

      });

    });

  });

  return items;

}



function groupItemsByCompany(items) {

  const groups = new Map();

  items.forEach((item) => {

    const key = item.company_id || item.company_name;

    if (!groups.has(key)) {

      groups.set(key, { company_name: item.company_name, certificates: [] });

    }

    groups.get(key).certificates.push(item);

  });

  return [...groups.values()];

}



export default function CertBorrowApplicationView({ formData = {}, snapshotItems = [] }) {

  const reasonItem = snapshotItems.find((i) => i.label === '申请原因');

  const daysItem = snapshotItems.find((i) => i.label === '借阅时长' || i.label === '借阅时长（天）' || i.label === '原件应归还期限');

  const borrowReason = formData.borrow_reason || reasonItem?.value || '';

  const parsedItems = parseItemsFromFormData(formData);
  const needsBorrowDays = formData.needs_borrow_days === 1 || formData.needs_borrow_days === true
    || formData.borrow_days != null
    || parsedItems.some((item) => isBorrowSealItem(item) || item.copy_type !== 'copy');

  const borrowDays = formData.borrow_days != null
    ? `${formData.borrow_days} 天`
    : (daysItem?.value || '');



  const items = parsedItems;

  const groups = groupItemsByCompany(items);



  return (

    <Form layout="vertical" disabled className="process-form-readonly cert-borrow-application-view">

      {borrowReason && (

        <Form.Item label="申请原因">

          <Input.TextArea value={borrowReason} rows={2} />

        </Form.Item>

      )}

      {needsBorrowDays && borrowDays && (

        <Form.Item label="应归还期限">

          <Input value={borrowDays} />

        </Form.Item>

      )}

      {groups.length > 0 && (

        <Form.Item label="借阅明细">

          <div className="cert-borrow-detail-list">

            {groups.map((entry) => (

              <div key={entry.company_name} className="cert-borrow-detail-group">

                <div className="cert-borrow-detail-company">{entry.company_name}</div>

                <div className="cert-borrow-detail-certs">

                  {(entry.certificates || []).map((cert) => (

                    <div key={`${entry.company_name}-${cert.cert_name}`} className="cert-borrow-detail-row">

                      <span className="cert-borrow-detail-name">

                        {cert.cert_name || cert.cert_type_name || '证照'}

                      </span>

                      {!isBorrowSealItem(cert) && (
                        <div className="cert-borrow-detail-meta">
                          <Tag className="cert-borrow-detail-type-tag">{borrowCopyTypeLabel(cert)}</Tag>
                          {cert.copy_type === 'copy' && isBorrowWatermarkEnabled(cert.need_watermark) ? (
                            <Tag color="blue" className="cert-borrow-detail-wm-tag">
                              水印：{cert.watermark_text || '是'}
                            </Tag>
                          ) : null}
                        </div>
                      )}

                    </div>

                  ))}

                </div>

              </div>

            ))}

          </div>

        </Form.Item>

      )}

    </Form>

  );

}


